import React, { useState, useEffect } from "react";
import { BackNextButton, AddButton, Modal, EditCard, Button, } from "../../../../../common";
import { EditCardItems } from "../EditCardItems";
import { AddKeyPersonnelForm } from "./AddKeyPersonnelForm";
import { ReactComponent as Pen } from "../../../../../../assets/images/companyIcons/pen.svg";
import { ReactComponent as Address } from "../../../../../../assets/images/companyIcons/CompanyProfile/address.svg";
import { useSelector, useDispatch } from "react-redux";
import { useGetCompanyQuery, useKeypersonneldetailsdraftFetchMutation, useDeleteKeyPersonnelDraftMutation, useUpdateKeyPersonnelMutation } from "../../../../../../store/Company/companyApiSlice";
import { setCurrentEditingCompany } from "../../../../../../store/Company/companySlice";
import { ReactComponent as Designation } from "../../../../../../assets/images/companyIcons/CompanyProfile/designation.svg";
import { ReactComponent as EmailIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/email.svg";
import { ReactComponent as NameIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/name.svg";
import { ReactComponent as TelephoneIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/telephone.svg";
import { AdminChecker } from "../../../../../../utils/Helper";
import { ReactComponent as Delete } from "../../../../../../assets/images/companyIcons/delete1.svg"
import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";

export const KeyPersonnel = ({ onPrev, onNext, onSkip, handleUpdateStatus, compRefetch }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [keyPersonnel, setKeyPersonnel] = useState([]);
  const [keyPersonnelDraft, setKeyPersonnelDraft] = useState([]);
  const [editKeyPersonnel, setEditKeyPersonnel] = useState(null);
  const [keyPersonnelDraftFetch] = useKeypersonneldetailsdraftFetchMutation();
  const [deleteDraft] = useDeleteKeyPersonnelDraftMutation()
  const [updateKeyPersonnel] = useUpdateKeyPersonnelMutation();
  const [dataChanged, setDataChanged] = useState(false);
  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);
  const { data, isLoading, refetch } = useGetCompanyQuery({
    companyId: currentEditingCompany?.companyID,
    token,
  });

  AdminChecker()

  useEffect(() => {
    if (data) {
      dispatch(setCurrentEditingCompany(data));
    }
  }, [data, dispatch, isOpen]);

  useEffect(() => {
    if (!currentEditingCompany) return;
    let resultArr = [];
    let Dettemp = currentEditingCompany?.companyKeyPersonnel?.forEach(function (obj) {
      if (obj?.key_personnelID?.is_deleted == 0) {
        resultArr.push(obj)
      }
    });
    setKeyPersonnel(resultArr);
    const companyStatus = async () => {
      let dataval = await keyPersonnelDraftFetch({
        companyID: currentEditingCompany?.companyID,
        token,
      });
      if (dataval?.data?.data) {
        let respData = dataval?.data?.data;
        let tempArr = [];
        let draft_ids = [];
        let ids = [];
        let main_ids = [];
        for (let i = 0; i < respData.length; i++) {
          draft_ids.push(respData[i]?.key_personnelID_id);
          tempArr.push(respData[i]);
        }
        currentEditingCompany?.companyKeyPersonnel?.forEach(function (obj) {
          if (obj?.key_personnelID?.is_deleted == 0) {

            ids.push(obj?.key_personnelID?.key_personnelID)
          }
        });
        ids.forEach(function (id) {
          if (!draft_ids.includes(id))
            main_ids.push(id)
        })
        currentEditingCompany?.companyKeyPersonnel?.forEach(function (obj) {
          if (obj?.key_personnelID?.is_deleted == 0) {

            if (main_ids.includes(obj?.key_personnelID?.key_personnelID)) {
              tempArr.push(obj?.key_personnelID)
            }
          }
        });
        setKeyPersonnelDraft(tempArr)
      }
    }
    companyStatus();
  }, [currentEditingCompany, dataChanged]);
  const modalHandleDelete = async (deleteInfo) => {
    if (deleteInfo?.key_personnel_draftID) {
      let dataval = await deleteDraft({
        data: deleteInfo?.key_personnel_draftID,
      });
      if (dataval?.data == null) {
        alert("Key Personnel Deleted Successfully");
        refetch();
        compRefetch();
        setDataChanged(!dataChanged);
        // window.location.reload()
      }
    } else if (deleteInfo?.key_personnelID) {
      let res = await updateKeyPersonnel({
        data: { is_deleted: 1 },
        key_personnelId: deleteInfo?.key_personnelID,
        token,
      }).unwrap();
      if (res?.is_deleted == 1) {
        handleUpdateStatus()
        alert("Key Personnel Deleted Successfully");
        // window.location.reload()
        refetch();
        compRefetch();
        setDataChanged(!dataChanged);
      }
    }
  }
  const modalHandle = (keyPersonnel) => {
    setIsOpen(!isOpen);
    setEditKeyPersonnel(keyPersonnel);
    refetch();
  };

  function createArrayFromObject(object) {
    let otherData = [
      "designation",
      "name",
      "work_email",
      "nationality",
      "work_mobile",
    ];
    let icons = {
      name: <NameIcon />,
      designation: <Designation />,
      work_email: <EmailIcon />,
      work_mobile: <TelephoneIcon />,
    };

    let data = [];

    for (let key in object) {
      if (otherData.includes(key)) {
        data.push({ [key]: object[key], icon: icons[key] });
      }
    }

    let keyValuePairs = data.map((item) =>
      Object.entries(item).map(([key, value]) => [key, value])
    );

    let html = keyValuePairs.map((item) => (
      <EditCardItems
        heading={item[0][0]?.replaceAll("_", " ")}
        subHeading={item[0][1]?.replace("|", "")}
        icon={item[1][1]}
      />
    ));
    return html;
  }

  return (
    <div className="mt-5 mr-20">
      {isOpen && (
        <Modal modalHandle={() => modalHandle(null)}>
          <AddKeyPersonnelForm
            editKeyPersonnel={editKeyPersonnel}
            modalHandle={modalHandle}
            refetch={refetch}
            compRefetch={compRefetch}
            dataChanged={dataChanged}
            setDataChanged={setDataChanged}
          />
        </Modal>
      )}
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2">
        Key Personnel
      </h3>

      <div className="border border-slate rounded-lg p-8 mb-6">
        <AddButton
          text="Add Key Personnel"
          buttonText="Add"
          onClick={() => modalHandle(null)}
        />
        <div className="grid grid-cols-2 gap-4">
          {keyPersonnelDraft.length <= 0 && keyPersonnel?.map((item) => (
            <EditCard>
              <div className="statusSection">
                {item.key_personnelID.status === "Verified" && (
                  <Verified />
                )}
                {item.key_personnelID.status === "Declined" && (
                  <Declined />
                )}
                {item.key_personnelID.status === "Skipped" && (
                  <Skipped />
                )}
                {(item?.key_personnelID?.status === "Requested" || item?.key_personnelID?.status === "raised" || item?.key_personnelID?.status === "pending" )&& (
                  <Requested />
                )}
              </div>
              <div className="h-[17rem] overflow-y-auto relative  my-2">
                {createArrayFromObject(item?.key_personnelID)}
              </div>
              <div className="actionseditDelete  gap-4">
                <Button
                  onClick={() => modalHandle(item?.key_personnelID)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative">
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button>
                <Button
                  onClick={() => modalHandleDelete(item?.key_personnelID)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative">
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button>
              </div>
            </EditCard>
          ))}
          {keyPersonnelDraft?.map((item) => (
            <EditCard>
              <div className="statusSection">
                {item?.status === "Verified" && (
                  <Verified />
                )}
                {item?.status === "Declined" && (
                  <Declined />
                )}
                {item?.status === "Skipped" && (
                  <Skipped />
                )}
                {(item?.status === "Requested" || item?.status === "raised"|| item?.status === "pending") && (
                  <Requested />
                )}
              </div>
              <div className="h-[17rem] overflow-y-auto relative  my-2">
                {createArrayFromObject(item)}
              </div>
              <div className="actionseditDelete  gap-4">
                <Button onClick={() => modalHandle(item)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative">
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button>
                <Button onClick={() => modalHandleDelete(item)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative">
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button>
              </div>
            </EditCard>
          ))}
        </div>
      </div>
      <BackNextButton
        onPrev={() => onPrev(3, "Authorized Signatory", "Details")}
        onNext={() => onNext(5, "Related Entities", "Details")}
        onSkip={() => onSkip(5, "Related Entities", "Details")}
      />
    </div>
  );
};
